<template>
    <div>
        <div class="flex items-center">
            <div class="mr-16 truncate font-semibold" v-show="showReplyForm">
                {{ form.subject }}
            </div>
            <simple-button
                class="ml-auto"
                icon="email-reply"
                @click="showReplyForm = !showReplyForm"
            >{{ $t('email_signatures.answer_directly') }}
            </simple-button>
        </div>
        <div v-show="showReplyForm" class="pt-24">
            <bcc-fields v-model="form.bcc" class="mb-16"></bcc-fields>
            <wysiwyg :placeholders="['application', 'company', 'user']" v-model="form.message" ref="content" class="mb-16">
                <template #after>
                    <div
                        class="flex p-16 border-t border-primary-20"
                        :class="[ signaturePreview ? 'items-start' : 'items-center text-primary-40' ]"
                    >
                        <div class="text-body flex-grow">
                            <span v-if="signaturePreview" v-html="signaturePreview"></span>
                            <span v-else>{{ $t('email_signatures.no_signature_selected') }}</span>
                        </div>
                        <select-dropdown
                            v-model="selectedSignature"
                            :auto-translate="false"
                            :options="signatureChoices"
                            class="min-w-240"
                        ></select-dropdown>
                    </div>
                </template>
            </wysiwyg>
            <file-upload v-model="form.attachments" multiple ref="fileUpload"/>
            <div class="flex justify-end pt-24">
                <simple-button
                    @click="send"
                    display="primary"
                    :loading="sendingMail"
                    icon="send"
                >{{ $t('general.send') }}</simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import sendsMails from '../../mixins/sendsMails';
import FileUpload from '../forms/FileUpload.vue';
import InputVue from '../forms/Input.vue';
import SelectDropdown from '../forms/SelectDropdown.vue';
import Wysiwyg from '../forms/Wysiwyg.vue';
import SimpleButton from './SimpleButton.vue';
import BccFields from "./BccFields.vue";

export default {
    components: {
        BccFields,
        'wysiwyg': Wysiwyg,
        'simple-button': SimpleButton,
        'file-upload': FileUpload,
        'simple-input': InputVue,
        'select-dropdown': SelectDropdown,
    },
    mixins: [
        sendsMails,
    ],
    data: function () {
        return {
            showReplyForm: false,
            wasOpened: false,
        }
    },
    methods: {
        async send () {
            await this.getBulkApplicationKey();

            if (this.bulkCount != 1) {
                return this[ADD_NOTIFICATION]({
                    type: 'error',
                    message: 'Something went wrong!',
                });
            }

            this.performSend()
                .then(() => {
                    this.$emit('close');
                }).catch(() => {
                    this[ADD_NOTIFICATION]({
                        type: 'error',
                        message: 'Something went wrong!',
                    });
                });
        }
    },
    watch: {
        showReplyForm (value) {
            if (value && !this.wasOpenend) {
                this.$refs.content.focusEditor();
                this.wasOpenend = true;
            }
        }
    }
}
</script>
